"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContainer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.div `
	padding: 30px;
	max-width: 60em;
	margin: auto;
	@media (max-width: 41em) {
		padding: 20px 0;
	}
`;
const FlexContainer = styled_components_1.default(Container) `
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	align-content: center;
`;
const PageContainer = (_a) => {
    var { children, flex } = _a, rest = __rest(_a, ["children", "flex"]);
    return react_1.default.createElement("main", { className: 'main-container', id: 'main-content', tabIndex: -1 }, flex ?
        react_1.default.createElement(FlexContainer, Object.assign({ "data-testid": 'content-container' }, rest), children)
        :
            react_1.default.createElement(Container, Object.assign({ "data-testid": 'content-container' }, rest), children));
};
exports.PageContainer = PageContainer;
